// 存储颜色缓存
const bgColorCache = new Map();

export function getImageBottomColor(imageUrl, position = 'bottom-left') {
  // 检查缓存
  if (bgColorCache.has(imageUrl)) {
    return Promise.resolve(bgColorCache.get(imageUrl));
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // 处理跨域图片
    img.src = imageUrl;

    const idleHandler = () => {
      try {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 只绘制需要检测的部分（性能优化）
        canvas.width = 1;
        canvas.height = 1;

        // 计算取样位置
        let sx = 4,
          sy = img.height - 4;
        if (position === 'bottom-right') {
          sx = img.width - 4;
        } else if (position === 'top-left') {
          sx = 4;
          sy = 4;
        } else if (position === 'top-right') {
          sx = img.width - 4;
          sy = 4;
        }

        ctx.drawImage(
          img,
          sx,
          sy,
          1,
          1, // 从源图像截取1像素
          0,
          0,
          1,
          1, // 在canvas上绘制1像素
        );

        const pixelData = ctx.getImageData(0, 0, 1, 1).data;
        const color = `rgba(${pixelData[0]}, ${pixelData[1]}, ${pixelData[2]}, ${
          pixelData[3] / 255
        })`;

        // 缓存结果
        bgColorCache.set(imageUrl, color);
        resolve(color);
      } catch (error) {
        console.warn('Failed to get image color:', error);
        resolve(null); // 失败时返回null
      }
    };

    img.onload = () => {
      // 图片加载完成后，在空闲时段处理
      if ('requestIdleCallback' in window) {
        requestIdleCallback(idleHandler);
      } else {
        // 浏览器不支持时降级处理
        setTimeout(idleHandler, 0);
      }
    };

    img.onerror = () => resolve(null);
  });
}
